import { Dispatch, SetStateAction } from 'react';
import { useLocalStorage } from 'react-use';

import { MedicalDocumentSimple, MedicalDocumentSimpleQuery } from '@dreryk/egabinet-document-repository-frontend-api';
import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import {
   LazyLoadedDataConfigurationByCqrsQuery,
   useLazyLoadedDataConfigurationByCqrsQuery,
} from '@dreryk/drerykweb-main-frontend';
import { Ordering } from '@dreryk/react-common';
import { Slot } from '@dreryk/watermelon';

const DEFAULT_ORDERINGS: Ordering<MedicalDocumentSimple>[] = [
   {
      descending: true,
      property: 'creationDate',
   },
];

const EXCLUDED_DOCUMENT_TYPES = ['ZLA_DOCUMENT_XML', 'DISCHARGE_SUMMARY'];
const REMOVED_MEDICAL_DOCUMENT_VISIBILITY_PREFERENCE_KEY = 'removedMedicalDocumentVisibilityPreference';

export const useMedicalDocumentRepositoryDataConfiguration = (
   patientId: Patient['id'],
   preferRemovedVisible: boolean
): LazyLoadedDataConfigurationByCqrsQuery<MedicalDocumentSimple> => {
   return useLazyLoadedDataConfigurationByCqrsQuery<MedicalDocumentSimple>(() => {
      const query = new MedicalDocumentSimpleQuery();
      query.excludedDocumentTypes = Slot.of(EXCLUDED_DOCUMENT_TYPES);
      query.patientId = patientId;
      query.includeRemoved = preferRemovedVisible;
      return query;
   }, DEFAULT_ORDERINGS);
};

type UseRemovedMedicalDocumentVisibilityPreferenceReturnFn = {
   preferRemovedMedicalDocumentVisible: boolean | undefined;
   setRemovedMedicalDocumentVisibilityPreference: Dispatch<SetStateAction<boolean | undefined>>;
};

export const useRemovedMedicalDocumentVisibilityPreference = (): UseRemovedMedicalDocumentVisibilityPreferenceReturnFn => {
   const [
      preferRemovedMedicalDocumentVisible,
      setRemovedMedicalDocumentVisibilityPreference,
   ] = useLocalStorage<boolean>(REMOVED_MEDICAL_DOCUMENT_VISIBILITY_PREFERENCE_KEY, false);
   return {
      preferRemovedMedicalDocumentVisible: preferRemovedMedicalDocumentVisible,
      setRemovedMedicalDocumentVisibilityPreference: setRemovedMedicalDocumentVisibilityPreference,
   };
};
